import { Component, Prop, h, Host, Element, Listen } from '@stencil/core';

@Component({
  tag: 'pn-choice-button',
  styleUrl: 'pn-choice-button.scss',
})
export class PnChoiceButton {
  /** This will be emitted on change and input */
  @Prop({ reflect: true }) value: any;
  /** The name of the checkbox group */
  @Prop() name?: string;
  /** The string you put here will be what you'd make the ID of a native checkbox, you can't name props "id" because it's reserved
   * so we went with the more descriptive name "choice", if you want to create labels for your checkbox, you will bind it to this ID
   */
  @Prop() choiceid: string;
  @Prop() type: string = 'checkbox';
  @Prop() disabled?: boolean = false;
  @Prop() checked?: boolean = false;
  @Prop({ mutable: true }) indeterminate?: boolean = false;

  @Element() hostElement: HTMLElement;

  @Listen('change')
  handlechange() {
    this.indeterminate = false;
  }

  componentDidLoad() {
    this.checkAndSetIndeterminateState();
  }

  componentDidUpdate() {
    this.checkAndSetIndeterminateState();
  }

  checkAndSetIndeterminateState() {
    let checkbox = this.hostElement.querySelector(`#${this.choiceid}`) as HTMLInputElement;

    if (checkbox) {
      checkbox.indeterminate = this.indeterminate;
    }
  }

  render() {
    return (
      <Host>
        <input type={this.type} id={this.choiceid} value={this.value} name={this.name || this.choiceid} disabled={this.disabled} checked={this.checked} />
        <label htmlFor={this.choiceid} class="pn-choice-button">
          <slot />
        </label>
      </Host>
    );
  }
}
